import { render, staticRenderFns } from "./HouseConnectionOrderProductSelection.vue?vue&type=template&id=b0cf1ffc&scoped=true&"
import script from "./HouseConnectionOrderProductSelection.vue?vue&type=script&lang=js&"
export * from "./HouseConnectionOrderProductSelection.vue?vue&type=script&lang=js&"
import style0 from "./HouseConnectionOrderProductSelection.vue?vue&type=style&index=0&id=b0cf1ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cf1ffc",
  null
  
)

export default component.exports